import styled from 'styled-components';

const Wrapper = styled.div`
  border: 5px solid #3598db;
  border-radius: 50%;
  height: 150px;
  margin: 0 auto 15px auto;
  overflow: hidden;
  width: 150px;

  img {
    padding: 5px;
    border-radius: 50%;
  }
`;

export default Wrapper;